import React, { ReactElement, useState } from 'react';
import { useIntl } from 'react-intl';
import messages from '../../../locales/messages';
import 'src/common/style/common.scss';
import { useAppContext } from 'src/apps/envizi-price-estimator/hooks/AppContext';
import { CLIP_LEVEL } from 'src/apps/envizi-price-estimator/constant/prices';
import { prop } from 'ramda';
import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';

export interface thanksProps {
  lowerPrice: string;
  higherPrice: string;
  insight: boolean;
  bpName: string;
}

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const Thanks = ({
  lowerPrice,
  higherPrice,
  insight,
  bpName,
}: thanksProps): ReactElement => {
  const { appState } = useAppContext();
  const intl = useIntl();
  const [showThanksModal, setShowThanksModal] = useState(true);
  const scope3Option = prop('scope3')(appState);
  const titleThanks: thanksTable[] = [
    { group: 'title', value: intl.formatMessage(messages.thankYouTitle) },
    {
      group: 'subTitle',
      value: intl.formatMessage(messages.thankYouMsg),
    },
  ];
  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: '',
    },
  ];

  const contentThanks: thanksTable[] = [];

  Number(lowerPrice) < CLIP_LEVEL &&
    !insight &&
    scope3Option === 'Yes' &&
    contentThanks.push({
      group: String(intl.formatMessage(messages.estimatedCosts)),
      value: `${formatter.format(Number(lowerPrice))} - ${formatter.format(
        Number(higherPrice),
      )}`,
    });

  bpName &&
    contentThanks.push({
      group: String(intl.formatMessage(messages.bp_title)),
      value: bpName,
    });

  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: String(intl.formatMessage(messages.returnToEstimator)),
    },
  ];

  return (
    <ThanksModal
      showThanksModal={showThanksModal}
      pageTitle="Envizi Price Estimator"
      object="Pricing Page"
      productTitle={'Envizi Price Estimator'}
      pageUrl={'/products/envizi/pricing/'}
      location={'Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    />
  );
};

export default Thanks;
